import { useState } from "react";
import { Link } from "react-scroll";
import "./Navbar.css";
import { Icon } from "react-icons-kit";
import { menu } from "react-icons-kit/feather/menu";
import { x } from "react-icons-kit/feather/x";
import myresume from "../file/Rekha-Yadav-Resume.pdf";

const Navbar = () => {
  const [toggle, setToggle] = useState(false);
  const [click, setClick] = useState(false);
  const closeMenu = () => setClick(false);
  const handleToggle = () => {
    setToggle(!toggle);
  };
  const handleResume = () => {
    window.open(
      "https://drive.google.com/file/d/1ROOVeuuELAGe2WC2oztiZTvbuX88dmGM/view?usp=sharing",
      "_blank",
      "noopener",
      "noreferrer"
    );
  };

  return (
    <div className="navbar">
      <h2 className="logo">
        <Link
          to="home"
          spy={true}
          duration={500}
          offset={-100}
          onClick={closeMenu}
          smooth={true}
        >
          Rekha Yadav
        </Link>
      </h2>
      <ul
        className={toggle ? "link_mobile" : "links"}
        onClick={() => setToggle(false)}
      >
        <li className="navbar-link about">
          <Link
            to="home"
            spy={true}
            duration={500}
            offset={-100}
            onClick={closeMenu}
            smooth={true}
          >
            HOME
          </Link>
        </li>
        <li className="navbar-link about">
          <Link
            to="about"
            spy={true}
            duration={500}
            offset={-100}
            onClick={closeMenu}
            smooth={true}
          >
            ABOUT
          </Link>
        </li>
        <li className="navbar-link project-link">
          <Link
            to="project"
            spy={true}
            duration={500}
            offset={-100}
            onClick={closeMenu}
            smooth={true}
          >
            PROJECT
          </Link>
        </li>
        <li className="navbar-link skill">
          <Link
            to="skill"
            spy={true}
            duration={500}
            offset={-100}
            onClick={closeMenu}
            smooth={true}
          >
            SKILLS
          </Link>
        </li>
        <li className="navbar-link contact">
          <Link
            to="contact"
            spy={true}
            duration={500}
            offset={-100}
            onClick={closeMenu}
            smooth={true}
          >
            CONTACT
          </Link>
        </li>
        <li className="navbar-link contact" onClick={() => handleResume}>
          {" "}
          <a
            href={myresume}
            onClick={handleResume}
            download
            target="_blank"
            rel="noopener noreferrer"
          >
            RESUME
          </a>
        </li>
      </ul>
      <button className="mobile_icon" onClick={handleToggle}>
        {toggle ? <Icon icon={x} size={20} /> : <Icon icon={menu} size={20} />}
      </button>
    </div>
  );
};
export default Navbar;
